import React from 'react';
import { FaChartLine } from 'react-icons/fa';
import './css_pages/UsageReport.css';

function UsageReport() {
  return (
    <div className="ur-page">
      <div className="ur-card">
        <div className="ur-icon"><FaChartLine /></div>
        <h1 className="ur-title">Usage Report</h1>
        <p className="ur-subtitle">Coming soon</p>
      </div>
    </div>
  );
}

export default UsageReport;